import request from "@/utils/request";

/**轮播图 */
export function slideshow(data) {
  return request({
    url: "/v1/64891d1cd09f2",
    method: "post",
    data,
  });
}

/**商品列表 */
export function commodityList(data) {
  return request({
    url: "/v1/654836e5537c4",
    method: "post",
    data,
  });
}

/**分类列表 */
export function categoryListings(data) {
  return request({
    url: "/v1/680357c3dfef2",
    method: "post",
    data,
  });
}

/**动态列表 */
export function dynamicList(data) {
  return request({
    url: "/v1/67ee0570d4930",
    method: "post",
    data,
  });
}

/**动态详情 */
export function dynamicDetail(data) {
  return request({
    url: "/v1/67ee0584a73f2",
    method: "post",
    data,
  });
}

/**商品详情 */
export function commodityDetail(data) {
  return request({
    url: "/v1/65483b5f97c31",
    method: "post",
    data,
  });
}

/**商品评价类型 */
export function evaluateType(data) {
  return request({
    url: "/v1/654859485bd30",
    method: "post",
    data,
  });
}

/**商品评价列表 */
export function evaluateList(data) {
  return request({
    url: "/v1/65485871409e3",
    method: "post",
    data,
  });
}

/**商品收藏 */
export function commodityCollect(data) {
  return request({
    url: "/v1/65549eb647ff5",
    method: "post",
    data,
  });
}

/**更新购物车 */
export function addCart(data) {
  return request({
    url: "/v1/654ade75d7027",
    method: "post",
    data,
  });
}

/**购物车列表 */
export function cartList(data) {
  return request({
    url: "/v1/654a1b35637b5",
    method: "post",
    data,
  });
}

/**购物车移入收藏 */
export function cartGoCollect(data) {
  return request({
    url: "/v1/65a496d395998",
    method: "post",
    data,
  });
}

/**购物车删除 */
export function cartRemove(data) {
  return request({
    url: "/v1/654a1c0070318",
    method: "post",
    data,
  });
}

/**收藏列表 */
export function collectList(data) {
  return request({
    url: "/v1/65549ed32f0ff",
    method: "post",
    data,
  });
}

/**地址列表 */
export function siteList(data) {
  return request({
    url: "/v1/65489e972a761",
    method: "post",
    data,
  });
}

/**添加地址 */
export function addSite(data) {
  return request({
    url: "/v1/6548a096aa007",
    method: "post",
    data,
  });
}

/**城市联动 */
export function cityLinkage(data) {
  return request({
    url: "/v1/654c3fb112cfa",
    method: "post",
    data,
  });
}

/**删除地址 */
export function deleteCity(data) {
  return request({
    url: "/v1/6548a240733ab",
    method: "post",
    data,
  });
}

/**地址详情 */
export function cityDetail(data) {
  return request({
    url: "/v1/6548a07d64b06",
    method: "post",
    data,
  });
}

/**地址修改 */
export function cityAmend(data) {
  return request({
    url: "/v1/6548a16849ece",
    method: "post",
    data,
  });
}

/**修改用户信息 */
export function amendMessage(data) {
  return request({
    url: "/v1/6486cc08551d6",
    method: "post",
    data,
  });
}

/**商品预下单 */
export function commodityOther(data) {
  return request({
    url: "/v1/654b4adf0028e",
    method: "post",
    data,
  });
}

/**统一下单 */
export function unifyPlace(data) {
  return request({
    url: "/v1/654b227c8f8fa",
    method: "post",
    data,
  });
}

/**足迹列表 */
export function footprintList(data) {
  return request({
    url: "/v1/6598ef90783cd",
    method: "post",
    data,
  });
}

/**售后列表 */
export function afterSaleList(data) {
  return request({
    url: "/v1/65547c65a0d0f",
    method: "post",
    data,
  });
}

/**订单列表 */
export function orderList(data) {
  return request({
    url: "/v1/654c81a07c0ce",
    method: "post",
    data,
  });
}

/**订单详情 */
export function orderDetail(data) {
  return request({
    url: "/v1/654c852159843",
    method: "post",
    data,
  });
}

/**取消订单 */
export function orderCancel(data) {
  return request({
    url: "/v1/65556da3e542f",
    method: "post",
    data,
  });
}

/**删除订单 */
export function orderDelete(data) {
  return request({
    url: "/v1/65556e4211a44",
    method: "post",
    data,
  });
}

/**订单角标 */
export function orderCornerMark(data) {
  return request({
    url: "/v1/655b21a7508a3",
    method: "post",
    data,
  });
}

/**余额支付 */
export function balancePayment(data) {
  return request({
    url: "/v1/6486dd3a42bcc",
    method: "post",
    data,
  });
}

/**确认收货 */
export function notarizeDelivery(data) {
  return request({
    url: "/v1/65558a97f36b8",
    method: "post",
    data,
  });
}

/**订单评价 */
export function orderEvaluate(data) {
  return request({
    url: "/v1/6555c92b70196",
    method: "post",
    data,
  });
}

/**平台公告列表 */
export function announcementList(data) {
  return request({
    url: "/v1/64895ec54cc00",
    method: "post",
    data,
  });
}

/**消息列表 */
export function informationList(data) {
  return request({
    url: "/v1/657aaa871299b",
    method: "post",
    data,
  });
}

/**消息角标 */
export function informationCorner(data) {
  return request({
    url: "/v1/657aaa3a4a0dc",
    method: "post",
    data,
  });
}

/**系统单页 */
export function systemPage(data) {
  return request({
    url: "/v1/6489408b9b421",
    method: "post",
    data,
  });
}

/**退款原因 */
export function refundCause(data) {
  return request({
    url: "/v1/655482fe5f9d1",
    method: "post",
    data,
  });
}

/**退款申请 */
export function refundApply(data) {
  return request({
    url: "/v1/65547d793754c",
    method: "post",
    data,
  });
}

/**一键已读 */
export function read(data) {
  return request({
    url: "/v1/67f7734e7ea36",
    method: "post",
    data,
  });
}

/**获取配置 */
export function getconf(data) {
  return request({
    url: "/v1/65571047446d4",
    method: "post",
    data,
  });
}

/**售后详情 */
export function refundDetail(data) {
  return request({
    url: "/v1/65547d60b4823",
    method: "post",
    data,
  });
}

/**快递公司 */
export function courierServicesCompany(data) {
  return request({
    url: "/v1/6556d3cda908d",
    method: "post",
    data,
  });
}

/**取消售后 */
export function cancelRefund(data) {
  return request({
    url: "/v1/65547e0fd7c0f",
    method: "post",
    data,
  });
}

/**售后寄回 */
export function returnAfterSale(data) {
  return request({
    url: "/v1/6556ebd0cecce",
    method: "post",
    data,
  });
}

/**手机号前缀 */
export function phonePrefix(data) {
  return request({
    url: "/v1/67fdb7287dc9c",
    method: "post",
    data,
  });
}

/**根据优惠券编号获取优惠券信息 */
export function discountsMessage(data) {
  return request({
    url: "/v1/68030c0d5602c",
    method: "post",
    data,
  });
}

/**获取支付宝预支付订单 */
export function AlipayOrder(data) {
  return request({
    url: "/v1/64803520af7e5",
    method: "post",
    data,
  });
}

/**获取微信预支付订单 */
export function WeChatOrder(data) {
  return request({
    url: "/v1/647fefdf51564",
    method: "post",
    data,
  });
}

/**获取下载链接 */
export function downloadLink(data) {
  return request({
    url: "/v1/6879a8606a469",
    method: "post",
    data,
  });
}

/**动态评论列表 */
export function dynamicEvaluateList(data) {
  return request({
    url: "/v1/68b53f2e2fee3",
    method: "post",
    data,
  });
}

/**动态评论 */
export function dynamicEvaluate(data) {
  return request({
    url: "/v1/68b53ef8592aa",
    method: "post",
    data,
  });
}

/**动态赞 */
export function dynamicPraise(data) {
  return request({
    url: "/v1/68b53e0182db7",
    method: "post",
    data,
  });
}

/**动态踩 */
export function dynamicTrample(data) {
  return request({
    url: "/v1/68b53e203bbb0",
    method: "post",
    data,
  });
}

/**学历 */
export function educationBackground(data) {
  return request({
    url: "/v1/68b53df3cabdd",
    method: "post",
    data,
  });
}

/**赞记录 */
export function praiseRecord(data) {
  return request({
    url: "/v1/68b53eb4e3220",
    method: "post",
    data,
  });
}

/**踩记录 */
export function trampleRecord(data) {
  return request({
    url: "/v1/68b53ea537e22",
    method: "post",
    data,
  });
}

/**我的评论 */
export function myComment(data) {
  return request({
    url: "/v1/68b53f49f04a8",
    method: "post",
    data,
  });
}

export function getTestData(data) {
  return request({
    url: "/v1/66ab0e2fa9435",
    method: "post",
    data,
  });
}

// 查看物流
export function getLogistics(data) {
  return request({
    url: "/v1/657a7693da6c6",
    method: "post",
    data,
  });
}



// WEBPACK FOOTER //
// ./src/api/user.js